import { settingsRoutes } from './settingsRoutes';
import { partnersRoutes } from './partnersRoutes';
import { clientsRoutes } from './clientsRoutes';
import { templatesRoutes } from './templatesRoutes';
import { resultRoutes } from './resultRoutes';
import { surveyTrackingRoutes } from './SurveyTrackingRoutes';

export const moduleRoutesList = [
	partnersRoutes,
	clientsRoutes,
	templatesRoutes,
	surveyTrackingRoutes,
	resultRoutes,
	settingsRoutes,

	// queriesRoutes,
];
